import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule } from '@progress/kendo-angular-grid';
import { ErrorsPage } from './errors-page';
import { SharedModule } from '../../shared.module';
import { DirectivesModule } from '../../../../directives/directives.module';
import { PtKendoModule } from '../../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ErrorsPage
  ],
  imports: [
    IonicPageModule.forChild(ErrorsPage),
    PtKendoModule,
    GridModule,
    SharedModule,
    DirectivesModule,
  ],
  providers: []
})
export class ErrorsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/errors-page/errors-page.module.ts